import { Box, Card, CardContent, Typography } from '@mui/material';
import { nanoid } from '@reduxjs/toolkit';
import { FC } from 'react';
import { useSelector } from 'react-redux';
import { getErrorCorrection } from 'redux/reducers/errorCorrections/selectors';
import { PreviousErrorsItem } from './PreviousErrorsItem';
// import { error } from '../../ErrorsTable/error-data';

const previousErrors = [
	{
		date: '2021-07-19, 12:00',
		description:
			'Product is not taxable in the store. Product was taxable at the moment of sale. If product is not taxable but should be write letter to the client. Product is not taxable in the store. Product was taxable at the moment of sale. If product is not taxable but should be write letter to the client.',
		actions: [
			'Remove order from clients account',
			'Extract VAT from order items',
			'Convert TBE items to the Goods',
		],
		communicationWithTheClient:
			'Product is not taxable in the store. Product was taxable at the moment of sale. If product is not taxable but should be write letter to the client. Product is not taxable in the store. Product was taxable at the moment of sale. If product is not taxable but should be write letter to the client.',
		comments:
			'Product is not taxable in the store. Product was taxable at the moment of sale. If product is not taxable but should be write letter to the client. Product is not taxable in the store. Product was taxable at the moment of sale. If product is not taxable but should be write letter to the client.',
	},
	{
		date: '2021-10-10, 15:17',
		description:
			'Product is not taxable in the store. Product was taxable at the moment of sale. If product is not taxable but should be write letter to the client. Product is not taxable in the store. Product was taxable at the moment of sale. If product is not taxable but should be write letter to the client.',
		actions: [
			'Remove order from clients account',
			'Extract VAT from order items',
			'Convert TBE items to the Goods',
		],
		communicationWithTheClient:
			'Product is not taxable in the store. Product was taxable at the moment of sale. If product is not taxable but should be write letter to the client. Product is not taxable in the store. Product was taxable at the moment of sale. If product is not taxable but should be write letter to the client.',
		comments:
			'Product is not taxable in the store. Product was taxable at the moment of sale. If product is not taxable but should be write letter to the client. Product is not taxable in the store. Product was taxable at the moment of sale. If product is not taxable but should be write letter to the client.',
	},
	{
		date: '2021-11-15, 09:45',
		description:
			'Product is not taxable in the store. Product was taxable at the moment of sale. If product is not taxable but should be write letter to the client. Product is not taxable in the store. Product was taxable at the moment of sale. If product is not taxable but should be write letter to the client.',
		actions: [
			'Remove order from clients account',
			'Extract VAT from order items',
			'Convert TBE items to the Goods',
		],
		communicationWithTheClient:
			'Product is not taxable in the store. Product was taxable at the moment of sale. If product is not taxable but should be write letter to the client. Product is not taxable in the store. Product was taxable at the moment of sale. If product is not taxable but should be write letter to the client.',
		comments:
			'Product is not taxable in the store. Product was taxable at the moment of sale. If product is not taxable but should be write letter to the client. Product is not taxable in the store. Product was taxable at the moment of sale. If product is not taxable but should be write letter to the client.',
	},
];

export const PreviousErrors: FC = () => {
	const error = useSelector(getErrorCorrection);

	return (
		<Card>
			<CardContent>
				<Box
					sx={{
						display: 'flex',
						flexDirection: 'column',
						gap: 2,
					}}
				>
					<Typography
						sx={{
							fontWeight: 'bold',
						}}
						color="primary"
					>
						Previous Errors
					</Typography>
					{error?.previousOrders.map(err => (
						<PreviousErrorsItem
							key={nanoid()}
							date={err.orderDate}
							// description={err.}
							actions={err.scriptHistory}
							communicationWithTheClient={err.communicationWithClient}
							comments={err.comment}
						/>
					))}
				</Box>
			</CardContent>
		</Card>
	);
};
